import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Text } from '@atomic';
import { Post } from '@domain';

const PostListWrapper = styled.div`
  max-width: 1440px;
  width: 100%;
`;

const TitleBox = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const PostListContainer = styled.ul`
  padding: 0;
  list-style: none;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  text-align: center;
  gap: 30px;
  margin-top: 20px;
`;

const PostList = ({ postList, listTitle }) => {
  return (
    <PostListWrapper>
      {listTitle && (
        <TitleBox>
          <Text strong textSize={20}>
            {listTitle}
          </Text>
        </TitleBox>
      )}
      {postList && (
        <PostListContainer>
          {postList?.map(
            (post) => post.image && <Post postInfo={post} key={post._id} />,
          )}
        </PostListContainer>
      )}
    </PostListWrapper>
  );
};

PostList.propTypes = {
  postList: PropTypes.array.isRequired,
  listTitle: PropTypes.string,
};

export default PostList;
